import Footer from "shared-components/footer";
import Header from "shared-components/header/Header";
import ApplicationFormV2Component from "shared-components/application-form-v2";

function ApplicationFormV2() {
  return (
    <div className="App relative">
      <Header />
      <main className="pt-12 md:pt-14 left-0 right-0 lg:px-[35px] lg:pb-[35px] bg-gray-100 min-h-[90vh] bg-white">
        <ApplicationFormV2Component />
      </main>
      <Footer className="left-0 right-0 pb-24 px-1 lg:pb-[35px] md:pb-10 bg-gray-100" />
    </div>
  );
}

export default ApplicationFormV2;
